import { System } from '@ecs/System';
import { HangarEffectKind, HangarEffectRequest } from '@components/HangarEffectRequest';
import { SoundManager, SoundType } from '@audio/SoundManager';
import { Effects } from '@/effects/Effects';

export const HANGAR_EFFECT_SOUNDS: Record<HangarEffectKind, SoundType> = {
  build: SoundType.SHIP_ASSEMBLE,
  repair: SoundType.REPAIR_WELD,
  deploy: SoundType.DEPLOY_CONFIRM,
  recall: SoundType.DEPLOY_RECALL,
  launch: SoundType.LAUNCH,
  deny: SoundType.UI_DENY,
  credits: SoundType.CREDITS_TICK,
};

const VOLUME: Record<HangarEffectKind, number> = {
  build: 0.8, repair: 0.7, deploy: 0.6, recall: 0.5, launch: 0.9, deny: 0.5, credits: 0.3,
};

/** Turns mothership action requests into particles and sound, like CollisionEffectSystem does for combat. */
export class HangarEffectSystem extends System {
  private soundManager = SoundManager.getInstance();

  update(_deltaTime: number): void {
    for (const entity of this.getEntitiesWithComponents(HangarEffectRequest)) {
      const request = entity.getComponent(HangarEffectRequest)!;
      this.spawn(request);
      this.soundManager.playSound(HANGAR_EFFECT_SOUNDS[request.kind], VOLUME[request.kind]);

      entity.removeComponent(HangarEffectRequest);
      if (entity.getComponents().length === 0) this.world.removeEntity(entity);
    }
  }

  private spawn({ kind, x, y, color, size }: HangarEffectRequest): void {
    switch (kind) {
      case 'build':
        Effects.warpIn(this.world, x, y, color);
        break;
      case 'repair':
        Effects.weld(this.world, x, y, 1.6);
        Effects.sparks(this.world, x, y, 0, Math.PI * 2, '#ffc266', 10, 3.5);
        break;
      case 'deploy':
        Effects.deployPulse(this.world, x, y, '#50ffa0', size * 1.6);
        break;
      case 'recall':
        Effects.deployPulse(this.world, x, y, '#8fa3bf', size * 1.4);
        break;
      case 'launch':
        Effects.launchFlare(this.world, x, y, color);
        break;
      case 'deny':
        Effects.deployPulse(this.world, x, y, '#ff5a5a', size * 1.3);
        break;
      case 'credits':
        Effects.creditSparkle(this.world, x, y);
        break;
    }
  }
}
